















































































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import InviteFriend from '@/store/modules/InviteFriend';
import AuthModule from '@/store/modules/Auth';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import Pagination from '@/components/Pagination.vue';
import PaginationMixin from '@/mixins/Pagination.vue';

@Component({
  components: {
    Table,
    Pagination,
  },
})
export default class AddUrl extends Mixins(ErrorHandleMixin, PaginationMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Partner',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Agent',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'URL',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Edit',
      },
    ],
  ];

  InviteFriendInstance = getModule(InviteFriend, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  searchText = '';

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  };

  editModel = {
    url: '',
    _id: '',
    partner: '',
    agent: '',
  };

  data = [];

  created() {
    this.fetchList();
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.calPagination({ ...this.paginationParams });
    this.fetchList();
  }

  async fetchList() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.InviteFriendInstance.FetchInviteFriends();
    if (res.code) {
      this.checkError(res);
    }
    this.WinLoseList = {
      data: this.InviteFriendInstance.inviteFriendList,
      pageAmount: Math.ceil(res.length / 100),
    };
    await this.calPagination({
      instance: 'WinLoseList',
      dataKey: 'data',
    });
    this.data = this.dataList;
    this.GeneralInstance.toggleLoading(false);
  }

  handleSearch() {
    this.data = this.InviteFriendInstance.inviteFriendList
      .filter((item) => item.agent && item.agent.includes(this.searchText));
  }

  handleEdit(item) {
    const {
      _id, inviteUrl, partner, agent,
    } = item;
    this.editModel._id = _id;
    this.editModel.url = inviteUrl;
    this.editModel.partner = partner;
    this.editModel.agent = agent;
  }

  handleCancel() {
    this.editModel = {
      url: '',
      _id: '',
      partner: '',
      agent: '',
    };
  }

  async handleSave() {
    const res = await this.InviteFriendInstance.UpdateUrl(this.editModel);
    this.checkError(res);
    await this.fetchList();
    this.handleCancel();
  }
}
